import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import AppLayout from "@/pages/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Actions from "@/pages/Actions";
import Evidence from "@/pages/Evidence";
import SARBuilder from "@/pages/SARBuilder";
import Analytics from "@/pages/Analytics";
import Audit from "@/pages/Audit";
import Compliance from "@/pages/Compliance";
import PublicSAR from "@/pages/PublicSAR";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/share/:token" element={<PublicSAR />} />
            <Route
              path="/"
              element={<Protected><AppLayout /></Protected>}
            >
              <Route index element={<Dashboard />} />
              <Route path="actions" element={<Actions />} />
              <Route path="evidence" element={<Evidence />} />
              <Route path="sar" element={<SARBuilder />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="audit" element={<Audit />} />
              <Route path="audit/:audit_id" element={<Audit />} />
              <Route path="compliance" element={<Compliance />} />
              <Route path="compliance/:review_id" element={<Compliance />} />
            </Route>
          </Routes>
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
